import { render, staticRenderFns } from "./AskForEventEditPage.vue?vue&type=template&id=183b159d&"
import script from "./AskForEventEditPage.vue?vue&type=script&lang=js&"
export * from "./AskForEventEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports